import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Menu } from 'lucide-react';
import { useCart } from '../../lib/cart';
export function MarketplaceHeader() {
  const {
    getItemCount
  } = useCart();
  const itemCount = getItemCount();
  return <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="flex justify-between items-center h-16" data-id="element-215">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-id="element-216">
            <div className="w-8 h-8 bg-brand-charcoal rounded-lg flex items-center justify-center" data-id="element-217">
              <span className="text-white font-bold text-lg leading-none" data-id="element-218">
                N
              </span>
            </div>
            <span className="font-bold text-xl tracking-tight text-brand-charcoal" data-id="element-219">
              NOIZA
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-220">
            <Link to="/" className="text-sm font-medium text-gray-600 hover:text-brand-charcoal transition-colors" data-id="element-221">
              Inicio
            </Link>
            <Link to="/restaurants" className="text-sm font-medium text-gray-600 hover:text-brand-charcoal transition-colors" data-id="element-222">
              Restaurantes
            </Link>
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-4" data-id="element-223">
            <Link to="/cart" className="relative p-2 text-gray-600 hover:text-brand-charcoal transition-colors rounded-full hover:bg-gray-50" data-id="element-224">
              <ShoppingBag className="w-6 h-6" data-id="element-225" />
              {itemCount > 0 && <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-white transform translate-x-1/4 -translate-y-1/4 bg-brand-amber rounded-full min-w-[20px] h-[20px]" data-id="element-226">
                  {itemCount}
                </span>}
            </Link>

            <button className="md:hidden p-2 text-gray-600 hover:text-brand-charcoal rounded-full hover:bg-gray-50" data-id="element-227">
              <Menu className="w-6 h-6" data-id="element-228" />
            </button>
          </div>
        </div>
      </div>
    </header>;
}